var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TimeLimitForSigningBox" },
    [
      _c("el-card", { staticClass: "mb5" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "20px" } },
          [
            _c(
              "el-form",
              { staticClass: "selectClass" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { staticStyle: { width: "auto" }, attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.lanshouTime"),
                            },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: false,
                                type: "daterange",
                                "value-format": "yyyy-MM-dd",
                                "default-time": ["00:00:00", "23:59:59"],
                                "range-separator": _vm.$t(
                                  "collectionCenter.to"
                                ),
                                "start-placeholder": _vm.$t(
                                  "collectionCenter.StartTime"
                                ),
                                "end-placeholder": _vm.$t(
                                  "collectionCenter.EndTime"
                                ),
                              },
                              on: { change: _vm.dateChange },
                              model: {
                                value: _vm.timeValue,
                                callback: function ($$v) {
                                  _vm.timeValue = $$v
                                },
                                expression: "timeValue",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("collectionCenter.site") } },
                          [
                            _c(
                              "div",
                              { staticClass: "dialogC" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    on: { focus: _vm.getNewestSite },
                                    model: {
                                      value: _vm.queryForm.params.siteId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "siteId",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.siteId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.siteIdList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("collectionCenter.LanShouPerson"),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "dialogC" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    on: { focus: _vm.chooseSite },
                                    model: {
                                      value: _vm.queryForm.params.scanUserId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "scanUserId",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.scanUserId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.driverList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.realName,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value:
                              "btn:collection-center:report:signAgeing:time-find",
                            expression:
                              "'btn:collection-center:report:signAgeing:time-find'",
                            arg: "remove",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.searchClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value:
                              "btn:collection-center:report:signAgeing:time-reset",
                            expression:
                              "'btn:collection-center:report:signAgeing:time-reset'",
                            arg: "remove",
                          },
                        ],
                        attrs: { icon: "el-icon-refresh", size: "mini" },
                        on: { click: _vm.resetClick },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")))]
                    ),
                    _vm.findActiveTime == "hzFind" && _vm.timeExportHZ
                      ? _c(
                          "el-button",
                          {
                            class:
                              _vm.exportList.length <= 0 && _vm.isClick
                                ? "onlyClickOnce10"
                                : "",
                            attrs: { icon: "el-icon-upload2", size: "mini" },
                            on: { click: _vm.download },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
                        )
                      : _vm._e(),
                    _vm.findActiveTime == "mxFind" && _vm.timeExportMX
                      ? _c(
                          "el-button",
                          {
                            class:
                              _vm.exportMXList.idList.length <= 0 && _vm.isClick
                                ? "onlyClickOnce10"
                                : "",
                            attrs: { icon: "el-icon-upload2", size: "mini" },
                            on: { click: _vm.downloadLogistics },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.export")))]
                        )
                      : _vm._e(),
                    _vm.findActiveTime == "hzFind" && _vm.timeAllExportHZ
                      ? _c(
                          "el-button",
                          {
                            class: _vm.isClickAll1 ? "onlyClickOnce10" : "",
                            attrs: { icon: "el-icon-upload", size: "mini" },
                            on: { click: _vm.downloadAll },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.allExport")))]
                        )
                      : _vm._e(),
                    _vm.findActiveTime == "mxFind" && _vm.timeAllExportMX
                      ? _c(
                          "el-button",
                          {
                            class: _vm.isClickAll2 ? "onlyClickOnce10" : "",
                            attrs: { icon: "el-icon-upload", size: "mini" },
                            on: { click: _vm.downloadAllMX },
                          },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.allExport")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-divider"),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              model: {
                value: _vm.findActiveTime,
                callback: function ($$v) {
                  _vm.findActiveTime = $$v
                },
                expression: "findActiveTime",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.summary"),
                    name: "hzFind",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          ref: "hzTable",
                          attrs: {
                            "max-height": 600,
                            border: "",
                            "show-summary": "",
                            "summary-method": _vm.getSummaries,
                            data: _vm.tableDate,
                          },
                          on: {
                            select: _vm.batchSelect,
                            "select-all": _vm.batchSelectAll,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "55" },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("collectionCenter.ind"),
                              type: "index",
                              width: "60",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.queryForm.pageNumber - 1) *
                                            _vm.queryForm.pageSize +
                                            scope.$index +
                                            1
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "driverName",
                              label: _vm.$t("collectionCenter.LanShouPeople"),
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "siteName",
                              label: _vm.$t("collectionCenter.collectionDot"),
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "scanDate",
                              label: _vm.$t("collectionCenter.lanshouT"),
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "sourceType",
                              label: _vm.$t("collectionCenter.DataSource"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.sourceType === 0
                                              ? "pda"
                                              : scope.row.sourceType === 1
                                              ? "pc"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "collectedCount",
                              label: _vm.$t(
                                "collectionCenter.receivedPackagesTotalNumber"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.hzTomx
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.details(
                                                  scope.row,
                                                  "collectBool"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.collectedCount)
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.collectedCount)
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "signedInCount",
                              label: _vm.$t(
                                "collectionCenter.TotalNumberOfParcelsSignedIn24Hours"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.hzTomx
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.details(
                                                  scope.row,
                                                  "twentyFoursignBool"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.signedInCount)
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.signedInCount)
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "unsignedQty",
                              label: _vm.$t(
                                "collectionCenter.in24UnsignedPackagesTotalNumber"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.hzTomx
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.details(
                                                  scope.row,
                                                  "unsignedBool"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.unsignedQty)
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(scope.row.unsignedQty)),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "unsignedCount",
                              label: _vm.$t(
                                "collectionCenter.over24HoursUnsignedPackagesTotalNumber"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.hzTomx
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.details(
                                                  scope.row,
                                                  "overtwentyFoursignBool"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.unsignedCount)
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.unsignedCount)
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": "150",
                              align: "center",
                              prop: "collectSuccessRate",
                              label: _vm.$t(
                                "collectionCenter.SigningRateWithin24Hours"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(scope.row.collectSuccessRate) +
                                          "%"
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c("el-pagination", {
                        staticStyle: { margin: "10px 0" },
                        attrs: {
                          layout: "total, sizes, prev, pager, next, jumper",
                          "current-page": _vm.queryForm.pageNumber,
                          "page-sizes": [10, 50, 100, 500, 1000],
                          "page-size": _vm.queryForm.pageSize,
                          total: _vm.total,
                          background: "",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageNumber", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageNumber", $event)
                          },
                          "update:pageSize": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageSize", $event)
                          },
                          "update:page-size": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageSize", $event)
                          },
                          "current-change": _vm.getTablePage,
                          "size-change": _vm.getPageSize,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm.findActiveTime == "mxFind"
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.particulars"),
                        name: "mxFind",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              ref: "mxTable",
                              attrs: {
                                "max-height": 600,
                                border: "",
                                data: _vm.mxtableDate,
                              },
                              on: {
                                select: _vm.batchSelectMX,
                                "select-all": _vm.batchSelectAllMX,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "55" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.ind"),
                                  type: "index",
                                  width: "60",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (_vm.queryFormMX.pageNumber -
                                                  1) *
                                                  _vm.queryFormMX.pageSize +
                                                  scope.$index +
                                                  1
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2346069176
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "orderNumber",
                                  label: _vm.$t(
                                    "collectionCenter.lanshouOrderNum"
                                  ),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "scanNumber",
                                  label: _vm.$t("collectionCenter.Barcode"),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "driverName",
                                  label: _vm.$t(
                                    "collectionCenter.LanShouPeople"
                                  ),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "scanTime",
                                  label: _vm.$t("collectionCenter.lanshouT"),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "siteName",
                                  label: _vm.$t(
                                    "collectionCenter.collectionDot"
                                  ),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "signerSiteName",
                                  label: _vm.$t(
                                    "collectionCenter.signerBelongsSite"
                                  ),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "signerUsername",
                                  label: _vm.$t("collectionCenter.signer"),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "signerTime",
                                  label: _vm.$t("collectionCenter.signT"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "right" },
                        [
                          _c("el-pagination", {
                            staticStyle: { margin: "10px 0" },
                            attrs: {
                              layout: "total, sizes, prev, pager, next, jumper",
                              "current-page": _vm.queryFormMX.pageNumber,
                              "page-sizes": [5, 10, 50, 100, 500, 1000],
                              "page-size": _vm.queryFormMX.pageSize,
                              total: _vm.totalMX,
                              background: "",
                            },
                            on: {
                              "update:currentPage": function ($event) {
                                return _vm.$set(
                                  _vm.queryFormMX,
                                  "pageNumber",
                                  $event
                                )
                              },
                              "update:current-page": function ($event) {
                                return _vm.$set(
                                  _vm.queryFormMX,
                                  "pageNumber",
                                  $event
                                )
                              },
                              "update:pageSize": function ($event) {
                                return _vm.$set(
                                  _vm.queryFormMX,
                                  "pageSize",
                                  $event
                                )
                              },
                              "update:page-size": function ($event) {
                                return _vm.$set(
                                  _vm.queryFormMX,
                                  "pageSize",
                                  $event
                                )
                              },
                              "current-change": _vm.getTablePageMX,
                              "size-change": _vm.searchClickMX,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }